export const tagSelector = (state) => state.tags.selected;
export const globalTagListSelector = (state) => state.tags.all;
